<ng-container *ngIf="pictureField?.length">
  <br/>
  <nb-card>
    <nb-card-header i18n="@@PictureWithTag"> {{ title }}
      <button i18n-nbTooltip="@@Upload" (click)="toggleUploader()" nbTooltip="Загрузить" nbButton status="control" style="margin-left: 10px">
        <nb-icon [icon]="addIcon"/>
      </button>

      <a [href]="original" target="_blank" i18n-nbTooltip="@@Delete" nbTooltip="Скачать" *ngIf="fileName" nbButton status="control" style="margin-left: 10px">
        <nb-icon icon="download"/>
      </a>

      <button i18n-nbTooltip="@@Delete" nbTooltip="Удалить фото" (click)="onDeleteConfirm()" *ngIf="picture" nbButton status="control" style="margin-left: 10px">
        <nb-icon icon="close-outline"/>
      </button>
    </nb-card-header>
    <div *ngIf="picture || showUploader">
      <nb-card-body class="file-card-body">
        <img src="{{ fileName }}" alt="" class="picView" *ngIf="fileName"/>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="showUploader">
          <formly-form [form]="form" [fields]="pictureField" [options]="options" [model]="model"></formly-form>
          <div class="my-drop-zone-info from-parent">
            <ng-content></ng-content>
          </div>
          <button nbButton status="primary" type="submit" [disabled]="!form.valid" i18n="@@Save">Сохранить</button>
        </form>
      </nb-card-body>
    </div>
  </nb-card>
</ng-container>
